import SecurityIcon from '@mui/icons-material/Security';
import CspmDetailBody from '../CspmDetailBody';

// Descriptor for the CSPM engine. Future engines add a sibling file with the
// same shape and register in registry.js.
export const cspmEngine = {
  id: 'cspm',
  label: 'Security Hub CSPM',
  color: '#4698D3',
  Icon: SecurityIcon,
  capability: {
    name: 'Posture management',
    source: 'Amazon Security Hub CSPM',
    description: 'Standards, controls, and a compliance score across your accounts.',
    items: ['FSBP', 'CIS AWS Foundations', 'NIST 800-53', 'PCI DSS'],
  },
  // sidebar sub-items shown under "Detection engines → Security Hub CSPM"
  nav: [
    { label: 'Summary', to: '/securityhub/cspm' },
    { label: 'Security standards', to: '/securityhub/cspm/standards' },
    { label: 'Findings', to: '/securityhub/cspm/findings' },
    { label: 'Enrollment', to: '/securityhub/cspm/enrollment' },
    { label: 'Settings', to: '/securityhub/cspm/settings' },
  ],
  enableRoute: '/securityhub/cspm', // where "Enable/Configure" routes
  DetailBody: CspmDetailBody,
};
